import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    locale: localStorage.getItem('locale') || 'zh',
  },
  getters: {
    locale: (state) => state.locale,
  },
  mutations: {
    setLocale(state, locale) {
      state.locale = locale
      localStorage.setItem('locale', locale)
    },
  },
  actions: {
    switchLocale({ commit }, locale) {
      commit('setLocale', locale)
    },
  },
  modules: {
  },
})
